import { assets } from '@pukka/common';
import { twMerge } from 'tailwind-merge';

import { Loader } from '../Loader';

interface NoDataDisplayProps {
  readonly isLoading: boolean;
  readonly title?: string;
  readonly placeholder?: (() => string | React.ReactElement | React.ReactNode) | React.ReactNode;
  readonly imageSize?: number;
  readonly imageSource?: string;
  readonly className?: string;
}

const { noData } = assets;

function NoDataDisplayV2({
  isLoading,
  title = 'No Data To Display',
  placeholder,
  imageSource = noData,
  imageSize = 200,
  className,
}: NoDataDisplayProps) {
  return (
    <div className={twMerge('flex h-full flex-col items-center justify-center', className)}>
      {isLoading ? (
        <Loader size={64} />
      ) : (
        <>
          <img src={imageSource} alt="no data in the table" width={imageSize} />
          <h2 className="mb-2 mt-6 font-medium">{title}</h2>
          {placeholder && typeof placeholder === 'function' ? placeholder() : null}
          {placeholder && typeof placeholder !== 'function' ? placeholder : null}
        </>
      )}
    </div>
  );
}

export { NoDataDisplayV2 };
